import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-xs-table-balance',
  templateUrl: './xs-table-balance.component.html',
  styleUrls: ['./xs-table-balance.component.scss'],
})
export class XsTableBalanceComponent implements OnInit {
  @Input() titleTable: string;
  @Input() currency: string;
  @Input() balance = [];
  //
  constructor() {}

  ngOnInit() {}
}
